module.exports = __webpack_public_path__ + "media/img/event/Virtual-Scholarship-Fair-2020-Feature-Layer-04-0f910cb77c1cb52e53f815dc818cbb21.svg";